import { css } from '@emotion/css';
import type {EmbedLayout} from 'Shared/model/Components';
import { Show } from 'solid-js';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { EmbedBody } from 'Shared/backend/widgets/EmbedBody';


export function initEmbed()
{
	return {layout:'embed',type:'iframe',height:{parent:true}};
}

export function Embed(P:EmbedLayout)
{
	const detailsStyle = css({
		display: 'flex',
		flexDirection: 'column',
		gap: '0.8em',
	});

	const lo = useLayout();

	return (
		<div class={detailsStyle}>
			<Show when={lo.layout()}>
				<EmbedBody {...P} heightOptions={['parent','ratio','height']} />
			</Show>
		</div>
	);
}

